<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iRqwkF/tc-custom/9780801876189.jpg?1705031866283" alt="This image is the cover for the book Secret of Apollo, New Series in NASA History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret of Apollo, New Series in NASA History
      </h1>
      <p class="bookDescription body article font2">
        <b>“Skillfully interweaving technical details and fascinating personalities, Johnson tells the history of systems management in the U.S. and Europe.” —Howard McCurdy, author of <i>Space and the American Imagination </i></b><br/><br/><b>Winner of the Emme Award for Astronautical Literature from the American Astronautical Society</b><br/><br/> How does one go about organizing something as complicated as a strategic-missile or space-exploration program? Stephen B. Johnson here explores the answer—systems management—in a groundbreaking study that involves Air Force planners, scientists, technical specialists, and, eventually, bureaucrats. Taking a comparative approach, Johnson focuses on the theory, or intellectual history, of “systems engineering” as such, its origins in the Air Force’s Cold War ICBM efforts, and its migration to not only NASA but the European Space Agency.<br/><br/> Exploring the history and politics of aerospace development and weapons procurement, Johnson examines how scientists and engineers created the systems management process to coordinate large-scale technology development, and how managers and military officers gained control of that process. “Those funding the race demanded results,” Johnson explains. “In response, development organizations created what few expected and what even fewer wanted—a bureaucracy for innovation. To begin to understand this apparent contradiction in terms, we must first understand the exacting nature of space technologies and the concerns of those who create them.”<br/><br/><b>“Johnson’s in-depth, nuts-and-bolts manual sheds much light on a seldom studied secret of our recent space history.” —<i>Space Review</i></b><br/><br/><b>“A book for general readers interested in business and management issues in the space program.” —<i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen B. Johnson
      </h2>
      
      <p class="authorDescription body article">Stephen B. Johnson  is an associate professor of space studies at the University of North Dakota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c32acb9